import { Popover } from '@hologram-dimension/popover';
import { EmptyState } from 'components';
import { useId } from 'react';
import { SimsDaoSim } from 'types/__generated__/SimInventoryApi';
import { SimKey } from 'types/common';
import { getUserFriendlyBytes } from 'utils/bytes';
import type {
  CustomCellRendererProps,
  CustomCellRendererReturn,
  SimCellRendererProps,
} from '../SimInventoryTableShared';
import styles from './ByteRenderer.module.css';

interface ByteRendererProps extends CustomCellRendererProps<SimsDaoSim, SimCellRendererProps> {}

const ByteRenderer = ({ value, columnValue }: ByteRendererProps): CustomCellRendererReturn => {
  const byteValue = value[columnValue as SimKey];
  const popoverId = useId();
  if (typeof byteValue !== 'number' || byteValue === 0) {
    return <EmptyState />;
  }

  return (
    <Popover
      content={getUserFriendlyBytes(byteValue, 'bytes')}
      id={popoverId}
      className={styles.wrapper}
    >
      {getUserFriendlyBytes(byteValue, 'short', 'decimal')}
    </Popover>
  );
};

export default ByteRenderer;
